import { useRouter } from 'next/router'
import { useTranslation } from 'next-i18next'
import React from 'react'

export const useHrefLang = () => {
  const { i18n } = useTranslation()
  const router = useRouter()
  const asPath = router.asPath === '/' ? '' : router.asPath
  const hasPage = !!router.query.page
  const shortPath = asPath.split('?')[0]!

  // TODO: voir comment récupérer correctement les locales depuis options
  const locales =
    'locales' in i18n.options ? (i18n.options.locales as string[]) : []

  const buildHrefLang = (locale: string, countryCode?: string) => {
    let cleanedPath = shortPath + (hasPage ? `?page=${router.query.page}` : '')

    const urlLocale = locales.find((l) => cleanedPath.startsWith(`/${l}/`))
    if (urlLocale) {
      cleanedPath = cleanedPath.replace(`/${urlLocale}/`, '/')
    }

    const localePart = router.defaultLocale === locale ? '' : `/${locale}`
    const finalPath = `${localePart}${
      router.defaultLocale === locale && cleanedPath === '' ? '/' : cleanedPath
    }`
    return (
      <link
        key={`${locale}${countryCode ? `-${countryCode}` : ''}-${cleanedPath}`}
        rel="alternate"
        hrefLang={`${locale}${countryCode ? `-${countryCode}` : ''}`}
        href={`${process.env.APP_URI}${finalPath}`}
      />
    )
  }

  return locales.reduce((acc: React.ReactNode[], lang) => {
    const links = [buildHrefLang(lang, 'fr'), buildHrefLang(lang)]
    // nl specific : add other countries
    if (lang.toLowerCase() === 'nl') {
      const countryLinks = ['be', 'nl'].map((country) =>
        buildHrefLang(lang, country)
      )
      acc.push(...countryLinks)
    }
    acc.push(...links)
    return acc
  }, [])
}
